import React, { useState } from "react";
import TmSelect from "./TmSelect.jsx";

const arab = "'Cairo','Segoe UI',sans-serif";

const DEVICES = {
  mobile: [
    { name: "Galaxy S22", w: 360, h: 780 },
    { name: "Galaxy S22 Ultra", w: 384, h: 854 },
    { name: "iPhone 15 Pro", w: 393, h: 852 },
    { name: "iPhone SE", w: 375, h: 667 },
    { name: "Pixel 8", w: 412, h: 915 },
  ],
  tablet: [
    { name: "iPad Mini", w: 768, h: 1024 },
    { name: "iPad Pro 11", w: 834, h: 1194 },
  ],
  desktop: [
    { name: "Laptop", w: 1280, h: 800 },
    { name: "Desktop", w: 1440, h: 900 },
    { name: "Full HD", w: 1920, h: 1080 },
  ],
};

const CatIcon = ({ d, on, label, onClick }) => (
  <button onClick={onClick} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, padding: "14px 22px", cursor: "pointer", fontFamily: arab, fontSize: 12.5, fontWeight: 800, border: "1px solid " + (on ? "var(--accent)" : "var(--line)"), background: on ? "color-mix(in srgb, var(--accent) 10%, transparent)" : "var(--surface)", color: on ? "var(--accent)" : "var(--text)", borderRadius: 0, boxShadow: on ? "3px 3px 0 color-mix(in srgb, var(--accent) 30%, transparent)" : "none" }}>
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={d} /></svg>
    {label}
  </button>
);

export default function DeviceLab() {
  const [cat, setCat] = useState("mobile");
  const [idx, setIdx] = useState(0);
  const [land, setLand] = useState(false);
  const [zoom, setZoom] = useState(0.75);
  const [cw, setCw] = useState("");
  const [chh, setChh] = useState("");
  const [rk, setRk] = useState(0);

  const dev = DEVICES[cat][idx] || DEVICES[cat][0];
  let W = cw ? parseInt(cw) || dev.w : dev.w;
  let H = chh ? parseInt(chh) || dev.h : dev.h;
  if (land) [W, H] = [H, W];
  const isMob = cat !== "desktop";
  const bezel = isMob ? 14 : 10;
  const radius = isMob ? 34 : 8;

  const inp = { fontFamily: arab, fontSize: 12.5, padding: "7px 10px", border: "1px solid var(--line)", borderRadius: 0, background: "var(--surface)", color: "var(--text)", boxSizing: "border-box" };
  const tbtn = (on) => ({ fontFamily: arab, fontSize: 12, fontWeight: 800, padding: "7px 14px", border: "1px solid " + (on ? "var(--accent)" : "var(--line)"), background: on ? "color-mix(in srgb, var(--accent) 10%, transparent)" : "transparent", color: on ? "var(--accent)" : "var(--text)", borderRadius: 0, cursor: "pointer" });

  return (
    <div style={{ fontFamily: arab, direction: "rtl" }}>
      <div style={{ fontSize: 12.5, color: "var(--faint)", marginBottom: 14, lineHeight: 1.8 }}>معاينة الموقع الحي كما يراه المستخدمون على كل جهاز - باختيار الفئة ثم الجهاز، وأي كسر في التصميم يظهر هنا يُصلح بالكود</div>
      <div style={{ display: "flex", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
        <CatIcon label="جوال" on={cat === "mobile"} onClick={() => { setCat("mobile"); setIdx(0); }} d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z M11 18h2" />
        <CatIcon label="آيباد" on={cat === "tablet"} onClick={() => { setCat("tablet"); setIdx(0); }} d="M5 2h14a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z M12 18h.01" />
        <CatIcon label="سطح المكتب" on={cat === "desktop"} onClick={() => { setCat("desktop"); setIdx(0); }} d="M2 4h20v12H2z M8 20h8 M12 16v4" />
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", padding: "10px 12px", border: "1px solid var(--line)", background: "var(--surface)", boxShadow: "3px 3px 0 color-mix(in srgb, var(--accent) 14%, transparent)", marginBottom: 18 }}>
        <TmSelect value={String(idx)} onChange={(v) => { setIdx(parseInt(v)); setCw(""); setChh(""); }} options={DEVICES[cat].map((d, i) => [String(i), d.name + " (" + d.w + "x" + d.h + ")"])} />
        <button style={tbtn(land)} onClick={() => setLand(!land)}>تدوير</button>
        <span style={{ fontSize: 11.5, color: "var(--faint)" }}>تكبير:</span>
        {[0.5, 0.75, 1].map((z) => <button key={z} style={tbtn(zoom === z)} onClick={() => setZoom(z)}>{z * 100}%</button>)}
        <span style={{ fontSize: 11.5, color: "var(--faint)" }}>مخصص:</span>
        <input value={cw} onChange={(e) => setCw(e.target.value)} placeholder="عرض" style={{ ...inp, width: 70, direction: "ltr", textAlign: "center" }} />
        <input value={chh} onChange={(e) => setChh(e.target.value)} placeholder="ارتفاع" style={{ ...inp, width: 70, direction: "ltr", textAlign: "center" }} />
        <button style={tbtn(false)} onClick={() => setRk(rk + 1)}>تحديث</button>
        <span style={{ fontSize: 12.5, fontWeight: 800, color: "var(--accent)", direction: "ltr", marginInlineStart: "auto" }}>{W} x {H} px</span>
      </div>
      <div style={{ display: "flex", justifyContent: "center", overflow: "auto", paddingBottom: 30 }}>
        <div style={{ width: (W + bezel * 2) * zoom, height: (H + bezel * 2 + (isMob ? 26 : 0)) * zoom, flexShrink: 0 }}>
          <div style={{ transform: "scale(" + zoom + ")", transformOrigin: "top right", width: W + bezel * 2 }}>
            <div style={{ background: "#111827", borderRadius: radius, padding: bezel, boxShadow: "8px 8px 0 color-mix(in srgb, var(--accent) 18%, transparent), 0 20px 50px rgba(0,0,0,.35)" }}>
              {isMob && !land && <div style={{ height: 22, display: "flex", justifyContent: "center", alignItems: "center" }}><div style={{ width: 90, height: 7, background: "#000", borderRadius: 99 }} /></div>}
              <iframe key={rk + "-" + cat + "-" + idx} src={window.location.origin} style={{ width: W, height: H, border: "none", borderRadius: isMob ? 18 : 4, background: "#fff", display: "block" }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
